import store from "@/store";
import moment from 'moment-timezone';
import Vue from "vue";

/**
 * 根据时区将时间戳转为特定格式的时间（统一使用GMT格式）
 * @param timestamp 时间戳【秒】
 * @param showTime 是否展示时分秒 默认是
 * @param format 时间格式 默认日月年
 * @param timeZone 时区 默认英国
 * @param showTimeZone 是否展示时区信息 默认是
 * @returns {string}
 */
export const formatTimestamp = (timestamp, showTime = true, format, timeZone, showTimeZone = true) => {
  if (!timestamp) return '-'
  // 获取当前用户ip
  const country = store.state.user.localInfo.country

  if (timeZone === 'GB') {
    timeZone = 'Europe/London'
  }
  // 处理时区
  let defaultTimeZone = country === 'CN' ? 'Asia/Shanghai' : 'Europe/London';

  const _timeZone = timeZone || defaultTimeZone
  // 处理时间格式
  let defaultFormat1 = country === 'CN' ? 'YYYY-MM-DD HH:mm:ss' : 'DD-MM-YYYY HH:mm:ss';
  let defaultFormat2 = country === 'CN' ? 'YYYY-MM-DD' : 'DD-MM-YYYY';
  const _format = showTime ? (format || defaultFormat1) : (format || defaultFormat2)

  const time = moment.tz(timestamp, _timeZone);

  let formattedTime = time.format(_format);

  // 只有在showTimeZone为true时才添加时区信息
  if (showTimeZone) {
    // 统一使用GMT格式显示时区
    const timezoneOffset = time.format('Z'); // 获取时区偏移，如 +08:00、+00:00等

    // 转换为GMT格式
    const offsetHours = parseInt(timezoneOffset.substring(1, 3));
    const offsetMinutes = parseInt(timezoneOffset.substring(4, 6));
    const sign = timezoneOffset.substring(0, 1);

    let gmtFormat;
    if (offsetMinutes === 0) {
      gmtFormat = `GMT${sign}${offsetHours}`; // GMT+8 或 GMT-5 或 GMT+0
    } else {
      gmtFormat = `GMT${sign}${offsetHours}:${offsetMinutes.toString().padStart(2, '0')}`; // GMT+5:30
    }

    formattedTime += ` ${gmtFormat}`;
  }

  return formattedTime;
}

/**
 * **
 *  * 根据时区 将特定格式的时间转为时间戳
 *  * @param dateTime 时间戳【秒】
 *  * @param timeZone 时区 默认英国
 *  * @param format 时间格式 默认日月年
 * @returns {number|string}
 */
export const convertToTimestamp = (dateTime, timeZone, format) => {
  if (!dateTime) return ''
  // 获取当前用户ip
  const country = store.state.user.localInfo.country
  // 处理时区
  let defaultTimeZone = country === 'CN' ? 'Asia/Shanghai' : 'Europe/London';
  const _timeZone = timeZone || defaultTimeZone
  // 处理时间格式
  let defaultFormat = country === 'CN' ? 'YYYY-MM-DD HH:mm:ss' : 'DD-MM-YYYY HH:mm:ss';
  const _format = format || defaultFormat

  // 根据时区和格式解析时间
  const time = moment.tz(dateTime, _format, _timeZone);

  // 返回时间戳（毫秒）
  return time.valueOf();
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 获取英国时区时间
export function getTimeInLondon() {
  const now = new Date()
  let options = {
    weekday: 'long',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZone: 'Europe/Brussels'
  };
  return now.toLocaleString('en-GB', options)
}


// 金额数字转成最小单位分
export function convertToScaledNumber(input) {
  // 确保输入是数字类型，如果不是，则尝试将其转换为数字
  const number = Number(input);

  // 检查转换是否成功（即输入是否可以被解析为数字）
  if (isNaN(number)) {
    return 0
  }

  // 将数字乘以 100 并返回结果
  return Vue.prototype.$decimal(number).mul(100).toNumber()
}

// 金额数字/100
export function toDividedNumber(input,decimalPlaces = 2) {
  // 确保输入是数字类型，如果不是，则尝试将其转换为数字
  const number = Number(input);

  // 检查转换是否成功（即输入是否可以被解析为数字）
  if (isNaN(number)) {
    return 0
  }

  // 将数字乘以 100 并返回结果
  return Vue.prototype.$decimal(number).div(100).toNumber(decimalPlaces)
}

/**
 * 判断文件类型
 * @param {string} fileName - 文件名或文件路径
 * @returns {string} 文件类型 (img, excel, pdf, word, zip, txt, file)
 */
export function getFileType(fileName) {
  if (!fileName || typeof fileName !== 'string') return 'file';

  // 获取文件扩展名
  const extension = fileName.toLowerCase().split('.').pop();

  // 图片类型
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff'];
  if (imageExtensions.includes(extension)) return 'img';

  // Excel类型
  const excelExtensions = ['xls', 'xlsx', 'xlsm', 'xlsb'];
  if (excelExtensions.includes(extension)) return 'excel';

  // PDF类型
  if (extension === 'pdf') return 'pdf';

  // ZIP类型
  const zipExtensions = ['zip', 'rar', '7z', 'tar', 'gz'];
  if (zipExtensions.includes(extension)) return 'zip';

  // 文本类型
  if (extension === 'txt') return 'txt';

  // 其他类型
  return 'fold';
}



// WEBPACK FOOTER //
// ./src/utils/index.js